import { GetProtectionByRNumberCommand } from "@/modules/landings/protection/commands/getProtectionByRNumberCommand";
import { Modal } from "antd";
import { runInAction, toJS } from "mobx";
import { useLocalObservable } from "mobx-react-lite";
import { useEffect, useMemo } from "react";
export const RNumberViewModel = (param)=>{
    let { apiService  } = param;
    const getProtectionRNumberCommand = useMemo(()=>new GetProtectionByRNumberCommand(apiService), [
        apiService
    ]);
    // const {authStore} = props
    const status = useLocalObservable(()=>({
            errors: [],
            initialized: false,
            loading: false,
            RNumberResult: [],
            resultStatus: false,
            initialStatus: {
                apiErrors: {}
            },
            initialValues: {
                number1: "",
                number2: "",
                number3: "",
                number4: ""
            }
        }));
    //
    const actions = useLocalObservable(()=>({
            async initialize (props) {
                status.RNumberResult = [];
            },
            async onSubmit (values, formikActions) {
                ;
                // status.resultStatus=true
                const dto = "".concat(values.number1, "-").concat(values.number2, "-").concat(values.number3, "-").concat(values.number4);
                ;
                try {
                    const response = await getProtectionRNumberCommand.execute({
                        r_number: dto
                    });
                    if (response.success) {
                        status.RNumberResult = [
                            response.protection
                        ];
                        ;
                        status.resultStatus = true;
                        actions.getResult();
                        Modal.success({
                            title: "조회 성공",
                            content: "조회결과를 확인해주세요"
                        });
                        runInAction(()=>{
                            status.resultStatus = true;
                        });
                    } else {
                        Modal.error({
                            title: "조회에 실패했습니다.",
                            content: "잠시 후 다시 시도해주세요."
                        });
                    }
                } catch (e) {
                    status.RNumberResult = [];
                    Modal.error({
                        title: "조회 결과가 없습니다",
                        content: "다시 조회해주세요"
                    });
                } finally{
                    formikActions.setSubmitting(false);
                    formikActions.resetForm();
                }
            },
            getResult () {
                // status.resultStatus = true
                return status.RNumberResult;
            },
            dispose () {}
        }));
    useEffect(()=>{
        actions.initialize({});
    }, []);
    return useLocalObservable(()=>({
            status,
            actions
        }));
};
